import "./sheets.css";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import Main from "./Main";
import Rings from "./individual/Rings";
import Ceilings from "./individual/Ceilings";
import Rafters from "./individual/Rafters";
import Trim from "./individual/Trim";
import Eaves from "./individual/Eaves";
import Hardware from "./individual/Hardware";
import WallStacks from "./individual/WallStacks";
import Additions from "./individual/Additions";
import { useState } from "react"

const SheetControl = ({ project, editProject }) => {
  const [stateProject, setStateProject] = useState(project);

  const handleEditProject = (e) => {
    const value = e.target.value;
    const name = e.target.name;

    let newState = { ...stateProject };
    newState[name] = value;

    setStateProject(newState);
    editProject(e);
  };

  return (
    <div id="sheets-container">
      <Tabs>
        <TabList>
          <Tab>Main</Tab>
          <Tab>Rings</Tab>
          <Tab>Ceilings</Tab>
          <Tab>Rafters</Tab>
          <Tab>Trim</Tab>
          <Tab>Eaves</Tab>
          <Tab>Hardware</Tab>
          <Tab>Wall Stacks</Tab>
          <Tab>Additions</Tab>
        </TabList>
        <TabPanel>
          <Main project={stateProject} handleEditProject={handleEditProject} />
        </TabPanel>
        <TabPanel>
          <Rings project={stateProject} handleEditProject={handleEditProject} />
        </TabPanel>
        <TabPanel>
          <Ceilings project={stateProject} handleEditProject={handleEditProject} />
        </TabPanel>
        <TabPanel>
          <Rafters project={stateProject} handleEditProject={handleEditProject} />
        </TabPanel>
        <TabPanel>
          <Trim project={stateProject} handleEditProject={handleEditProject} />
        </TabPanel>
        <TabPanel>
          <Eaves project={stateProject} handleEditProject={handleEditProject} />
        </TabPanel>
        <TabPanel>
          <Hardware project={stateProject} handleEditProject={handleEditProject} />
        </TabPanel>
        <TabPanel>
          <WallStacks project={stateProject} handleEditProject={handleEditProject} />
        </TabPanel>
        <TabPanel>
          <Additions project={stateProject} handleEditProject={handleEditProject} />
        </TabPanel>
      </Tabs>
    </div>
  );
};

export default SheetControl;
